import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';
import { DayOfWeek } from '../../constants/index';

const EditLeagueScheduleModal = ({ isOpen, toggle, onSave, schedule }) => {
  const [editedSchedule, setEditedSchedule] = useState({
    league: null,
    title: '',
    day_of_week: '',
    sort_order: 99
  });

  useEffect(() => {
    if (schedule) {
      setEditedSchedule({
        league: schedule.league,
        title: schedule.title || '',
        day_of_week: schedule.day_of_week !== null && schedule.day_of_week !== undefined ? schedule.day_of_week : '',
        sort_order: schedule.sort_order || 99
      });
    }
  }, [schedule]);

  const handleSave = () => {
    onSave({ ...editedSchedule, day_of_week: editedSchedule.day_of_week === '' ? null : editedSchedule.day_of_week });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedSchedule(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Schedule</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="title">Schedule Title *</Label>
          <Input
            type="text"
            id="title"
            name="title"
            value={editedSchedule.title}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="day_of_week">Day of Week</Label>
          <Input
            type="select"
            id="day_of_week"
            name="day_of_week"
            value={editedSchedule.day_of_week}
            onChange={handleChange}
          >
            <option value="">-- Select a day --</option>
            {Object.keys(DayOfWeek).map((key) => (
              <option key={key} value={key}>{DayOfWeek[key]}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="sort_order">Sort Order</Label>
          <Input
            type="number"
            id="sort_order"
            name="sort_order"
            value={editedSchedule.sort_order}
            onChange={handleChange}
            placeholder="99"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!editedSchedule.title}>
          Save Changes
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditLeagueScheduleModal;
